import { make } from "vuex-pathify";
import { getAPI, postAPI, getDownloadAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
  loading: false,
};

// getters
const getters = {};

// actions
const actions = {

  retrieveSilos({ commit }, id) {
    commit("SET_LOADING", true);
    return getAPI("silo/retrieveSilos", id).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveSilosByProductId({ commit }, filter) {
    commit("SET_LOADING", true);
    return getAPI("silo/retrieveSilosByProductId", filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveSilosByProductBrandAndField({ commit }, filter) {
    commit("SET_LOADING", true);
    return getAPI("silo/retrieveSilosByProductBrandAndField", filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  add({ commit }, siloToSave) {
    commit("SET_LOADING", true);
    return postAPI("siloManager/add", siloToSave).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  addTara({ commit }, siloToSave) {
    commit("SET_LOADING", true);
    return postAPI("siloManager/addTara", siloToSave).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  clear({ commit }, siloToSave) {
    commit("SET_LOADING", true);
    return postAPI("siloManager/clear", siloToSave).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveSilosToClear({ commit }, id) {
    commit("SET_LOADING", true);
    return getAPI("silo/retrieveSilosToClear", id).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  confirmClear({ commit }, siloToSave) {
    commit("SET_LOADING", true);
    return postAPI("siloManager/confirmClear", siloToSave).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveFieldByProductIdInProduction({ commit }, product) {
    commit("SET_LOADING", true);
    return getAPI("field/retrieveFieldByProductIdInProduction", product).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveFieldLotsByProductIdAndFieldInProduction({ commit }, filter) {
    commit("SET_LOADING", true);
    return getAPI("field/retrieveFieldLotsByProductIdAndFieldInProduction", filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveDiscardSiloProducts({ commit }, filter) {
    commit("SET_LOADING", true);
    return getAPI("silo/retrieveDiscardSiloProducts", filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveMovements({ commit }, filter) {
    commit("SET_LOADING", true);
    return getAPI("silo/retrieveMovements", filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  saveSiloTrx({ commit }, siloToSave) {
    commit("SET_LOADING", true);
    return postAPI("siloManager/saveSiloTrx", siloToSave).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  saveSiloTrxInput({ commit }, siloToSave) {
    commit("SET_LOADING", true);
    return postAPI("siloManager/saveSiloTrxInput", siloToSave).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveMovementsBySearch({ commit }, filter) {
    commit("SET_LOADING", true);
    return getAPI("silo/retrieveMovementsBySearch", filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  exportExcelSilos({ commit } , filter) {
    commit("SET_LOADING", true);
    return getDownloadAPI("silo/exportExcelSilos" , filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  exportExcelExportSilos({ commit } , filter) {
    commit("SET_LOADING", true);
    return getDownloadAPI("silo/exportExcelSilosMovements" , filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  partialClear({ commit }, trxList) {
    commit("SET_LOADING", true);
    return postAPI("siloManager/partialClear", trxList)
      .then((res) => res)
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },

  countMovements({ commit }, filter) {
    commit("SET_LOADING", true);
    return getAPI("silo/countMovements", filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },
  

};

// mutations
const mutations = {
  ...make.mutations(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};